module.exports = __webpack_public_path__ + "img/borigenbetzel.cc9acc68.webp";